import { RoutePaths } from "@/config/route-paths";

export function getCredentialInfoDialogBack({
  customerId,
  organizationId,
  sport,
}: {
  customerId: number;
  organizationId: string;
  sport: string;
}) {
  return RoutePaths.credentials.list({ customerId, organizationId, sport });
}
